import React from'react';

const ConfirmationModal = ({ 
 message ='Are you sure?', 
 title ='Confirm', 
 onConfirm, 
 onCancel,
 confirmText ='Yes',
 cancelText ='No',
 confirmButtonClass ='bg-red-600 hover:bg-red-700',
 show = true
}) => {
 if (!show) return null;

 const handleBackdropClick = (e) => {
 if (e.target === e.currentTarget && onCancel) {
 onCancel();
 }
 };

 return (
 <div 
 className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000] p-4"style={{ zIndex: 10000 }}
 onClick={handleBackdropClick}
 >
 <div 
 className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-slideUp"onClick={(e) => e.stopPropagation()}
 >
 <div className="mb-6">
 <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-orange-100 mb-4">
 <svg className="h-8 w-8 text-orange-600"fill="none"stroke="currentColor"viewBox="0 0 24 24">
 <path strokeLinecap="round"strokeLinejoin="round"strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
 </svg>
 </div>
 <h2 className="text-xl font-bold text-gray-900 text-center mb-2">{title}</h2>
 <p className="text-gray-600 text-center">{message}</p>
 </div>
 <div className="flex gap-3 justify-center">
 <button
 onClick={onCancel}
 className="px-6 py-2 rounded-lg font-semibold transition-colors bg-gray-200 text-gray-800 hover:bg-gray-300">
 {cancelText}
 </button>
 <button
 onClick={onConfirm}
 className={`px-6 py-2 rounded-lg font-semibold text-white transition-colors ${confirmButtonClass}`}
 >
 {confirmText}
 </button>
 </div>
 </div>
 </div>
 );
};

export default ConfirmationModal;



























